module.exports = __webpack_public_path__ + "img/shop-by-style-filter-navy.d80b8491.png";